/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

/**
 * Resolves which language variant of a Language-Filterable Attribute
 * instance should currently be displayed.
 *
 * Resolution order:
 * 1. The Instance Override, if set and present in `availableLanguages`.
 * 2. The page-wide Selected Language, if set and present in `availableLanguages`.
 * 3. `'en'`, if present in `availableLanguages`.
 * 4. The first entry in `availableLanguages` (array/data order, never
 *    schema-declaration order).
 *
 * Pure function: no Angular DI, no side effects. Fallback is silent — the
 * caller must not attempt to reconstruct "was this a fallback?" from the
 * returned value.
 *
 * @param availableLanguages - The language codes present in this instance's own data.
 * @param override - This instance's Instance Override, or null if none is set.
 * @param selectedLanguage - The page-wide Selected Language, or null if none is set yet.
 * @returns The language code to display for this instance, or `undefined` when no language entries exist.
 */
export function resolveEffectiveLanguage(
  availableLanguages: string[],
  override: string | null,
  selectedLanguage: string | null,
): string | undefined {
  if (override && availableLanguages.includes(override)) {
    return override;
  }
  if (selectedLanguage && availableLanguages.includes(selectedLanguage)) {
    return selectedLanguage;
  }
  if (availableLanguages.includes('en')) {
    return 'en';
  }
  return availableLanguages[0];
}
